import { Button } from '@mantine/core';

interface GenerateTestMessageButtonProps {
    onClick: () => void;
}

export const GenerateTestMessageButton = ({ onClick }: GenerateTestMessageButtonProps) => {
    return (
        <Button 
            type="button" 
            variant="light"
            onClick={onClick}
        >
            Generate Test Message
        </Button>
    );
};
